module.exports = __webpack_public_path__ + "img/lacantina.14bfa056.jpg";